import type { CalloutVariant } from "@productlane/lib/src/tiptap/extensions/callout-variant"
import { DEFAULT_CALLOUT_VARIANT } from "@productlane/lib/src/tiptap/extensions/callout-variant"

import type { MdxBlockReader } from "./registry"

const VARIANT_BY_TAG: Record<string, CalloutVariant> = {
	Note: "note",
	Info: "neutral",
	Tip: "tip",
	Check: "check",
	Warning: "warning",
	Danger: "danger",
	Error: "danger",
	Success: "check",
	// A custom callout's own colour and icon have no place in our schema.
	Callout: "note",
}

const TAGS = Object.keys(VARIANT_BY_TAG).join("|")

export const calloutsReaders: MdxBlockReader[] = [
	{
		name: "callout",
		pattern: new RegExp(`<(${TAGS})\\b[^>]*>([\\s\\S]*?)<\\/\\1>`, "g"),
		render: (match, parseBody) => {
			const variant = VARIANT_BY_TAG[match[1] ?? ""] ?? DEFAULT_CALLOUT_VARIANT
			const attribute =
				variant === DEFAULT_CALLOUT_VARIANT ? "" : ` data-callout="${variant}"`
			return `<blockquote${attribute}>${parseBody(match[2] ?? "")}</blockquote>`
		},
	},
]
